<template>
  <div style="margin-top: 15px; width: 100%;">
    <div v-if="index == 0"><span class="el-icon-top"></span>上拉加载更多</div>
    <div v-else-if="index == 1">
      <span class="el-icon-loading"></span>
      正在加载中...
    </div>
    <div v-else-if="index == 2">
      没有更多数据了
    </div>
  </div>
</template>

<script>
  export default {
    name: "bottom-Loading-vue",
    props: {
      index: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {

      }
    },

    mounted() {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/BottomLoading.vue